// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2883":"3019b7dab54c6367","2888":"646868112cd49673","6433":"f3a3a9762c5a92bd"}[chunkId] + ".css";
};